// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"540":"97873099","956":"625078df"}[chunkId] + ".js";
};